<template>
  <div class="px-4 py-2">
    <div v-if="isLoading" class="d-flex flex-column align-center justify-center py-4 w-100">
      <VProgressCircular indeterminate color="primary" />
    </div>
    <div v-else>
      <div v-if="answer.isNoBid" class="px-2 py-2">
        <VChip color="red" variant="flat">No-Bid</VChip>
        <div class="mt-4"><b>No-Bid Reason:</b></div>
        <div class="mt-4" v-if="answer.noBidReason" v-html="answer.noBidReason"></div>
        <VBtn v-if="!isPreview" @click="openDeleteAnswerModal" variant="text" color="red" class="mt-2">
          Remove No-Bid
        </VBtn>
      </div>
      <div v-else-if="answer.supplierAnswer" class="px-2 py-2">
        <div v-html="answer.supplierAnswer"></div>
        <VBtn v-if="!isPreview" @click="openDeleteAnswerModal" variant="text" color="red" class="mt-2">
          Remove Answer
        </VBtn>
      </div>
      <div v-else-if="!isPreview" class="px-2 py-2">
        <VBtn variant="text" color="primary" class="mt-2" @click="openAddAnswerModal"> Add Answer</VBtn>
        <VBtn variant="text" color="red" class="mt-2" @click="openNoBidAnswerModal"> No-Bid</VBtn>
      </div>
    </div>
    <AddAnswerModal
      v-model="isShowAddAnswerModal"
      :type="type"
      :inviteId="inviteId"
      :categoryId="categoryId"
      :questionId="questionId"
      @saved="getAnswer"
    />
    <AddNoBidAnswerModal
      v-model="isShowNoBidModal"
      :type="type"
      :inviteId="inviteId"
      :categoryId="categoryId"
      :questionId="questionId"
      @saved="getAnswer"
    />
    <DeleteAnswerModal
      v-model="isShowDeleteAnswerModal"
      :inviteId="inviteId"
      :categoryId="categoryId"
      :questionId="questionId"
      @deleted="getAnswer"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
// Service
import invitesService from '@/services/invites-service/invites.service';
// Utils
import { formatSupplierAnswer } from '@/utils/formatData';
// Components
import AddAnswerModal from '@/components/modals/AddAnswerModal/AddAnswerModal.vue';
import AddNoBidAnswerModal from '@/components/modals/AddNoBidAnswerModal/AddNoBidAnswerModal.vue';
import DeleteAnswerModal from '@/components/modals/DeleteAnswerModal/DeleteAnswerModal.vue';
export default {
  name: 'SupplierAnswer',

  emits: ['update:modelValue'],

  components: {
    AddAnswerModal,
    AddNoBidAnswerModal,
    DeleteAnswerModal
  },

  props: {
    type: {
      type: String
    },
    isPreview: {
      type: Boolean,
      default: false
    },
    inviteId: {
      type: String
    },
    categoryId: {
      type: String
    },
    questionId: {
      type: String
    }
  },

  data() {
    return {
      isLoading: false,
      answer: {
        answerId: '',
        supplierAnswer: '',
        isNoBid: false,
        noBidReason: ''
      },
      // Add Answer
      isShowAddAnswerModal: false,
      // No-Bid
      isShowNoBidModal: false,
      // Delete Answer
      isShowDeleteAnswerModal: false
    };
  },

  mounted() {
    this.getAnswer();
  },

  methods: {
    ...mapActions('main', ['showSnackbar', 'startLoading', 'stopLoading']),
    async getAnswer() {
      this.isLoading = true;
      this.answer = {
        answerId: '',
        supplierAnswer: '',
        isNoBid: false,
        noBidReason: ''
      };
      try {
        const payload = {
          inviteId: this.inviteId,
          categoryId: this.categoryId,
          questionId: this.questionId
        };
        const { supplierAnswer, status } = await invitesService.getSupplierAnswer(payload);
        console.log(supplierAnswer, status);
        if (supplierAnswer) {
          this.answer = formatSupplierAnswer(supplierAnswer);
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.$emit('update:modelValue', this.answer);
        this.isLoading = false;
      }
    },
    // Ansert - Add
    openAddAnswerModal() {
      this.isShowAddAnswerModal = true;
    },
    // Ansert - Add
    openNoBidAnswerModal() {
      this.isShowNoBidModal = true;
    },
    // Delete Answer
    openDeleteAnswerModal() {
      this.isShowDeleteAnswerModal = true;
    }
  }
};
</script>
